import {APP_FEATURES_PREFIX} from "./preferences_slice.js";
import {selectPreference} from "./select_preference.js";

export const selectAppFeature = k => selectPreference([`${APP_FEATURES_PREFIX}.${k}`]);
